var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarToolbarProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blank-calendar 2",
    clipPath: "url(#clip0_2864_9181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16392 0.807512V1.61502H2.33294H0.501953V8.80751V16H8.42684H16.3517V8.80751V1.61502H14.5207H12.6897V0.807512V0H12.0982H11.5066V0.807512V1.61502H8.42684H5.34702V0.807512V0H4.75547H4.16392V0.807512ZM1.68505 4.03756V5.277H8.42684H15.1686V4.03756V2.79812H8.42684H1.68505V4.03756ZM1.68505 10.6385V14.8169H8.42684H15.1686V10.6385V6.46009H8.42684H1.68505V10.6385Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2864_9181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.427734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarToolbarProjects);
export default __webpack_public_path__ + "static/media/icon--calendar-toolbar-projects.d15e7a1c5a3d027c05e9a617e5c6e6f9.svg";
export { ForwardRef as ReactComponent };